import React from "react";

const STORAGE_KEY = "tryon-theme";

function applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
    try {
        localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
        /* private mode */
    }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "light" ? "#f8fafc" : "#10100f");
}

export default function ThemeToggle() {
    const [theme, setTheme] = React.useState(() =>
        document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark"
    );

    const isDark = theme === "dark";

    const onClick = () => {
        const next = isDark ? "light" : "dark";
        applyTheme(next);
        setTheme(next);
    };

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
            aria-pressed={isDark}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-hairline bg-sheet text-ink hover:bg-tray"
        >
            {isDark ? (
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
                    <circle cx="12" cy="12" r="4" />
                    <path strokeLinecap="round" d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
                </svg>
            ) : (
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 14.5A8.5 8.5 0 1 1 9.5 3 7 7 0 0 0 21 14.5z" />
                </svg>
            )}
        </button>
    );
}
